export default __webpack_public_path__ + "static/media/Padron_MagnumOpen.fc57d2dd.jpg";